module.exports = __webpack_public_path__ + "img/20190622141957微信截图_20190622142356.1fa31f68.png";